@if (pwaInstallService.canShowBanner()) {
    <div class="pwa-install-banner">
        <img class="app-icon" src="/assets/favicons/web-app-manifest-192x192.png" alt="TSned"/>
        <div class="text">
            <strong>Installeer TSned</strong>
            <span>Voeg de app toe aan je beginscherm voor snellere toegang.</span>
        </div>
        <div class="actions">
            <button mat-flat-button (click)="install()">Installeren</button>
            <button mat-icon-button (click)="dismiss()" aria-label="Sluiten">
                <mat-icon class="fa-solid fa-xmark"></mat-icon>
            </button>
        </div>
    </div>
}
